<div class="certificates-page" data-tour="case-firma-root">

    <!-- ====================================================== -->
    <!-- PANEL PRINCIPAL -->
    <!-- ====================================================== -->

    <div class="certificates-panel">

        <!-- ================================================== -->
        <!-- TOOLBAR -->
        <!-- ================================================== -->

        <div class="certificates-toolbar">

            <!-- ACCIONES IZQUIERDA -->

            <div class="toolbar-actions">

                <!-- AGREGAR CERTIFICADO - NO GRUPO -->

                <button type="button" class="btn-add-certificate" *ngIf="!es_grupo"
                    (click)="openBusquedaCertificado(content)" data-tour="btn-agregar-certificado">

                    <i class="fa-solid fa-plus"></i>

                    <span>
                        Agregar certificado
                    </span>

                </button>


                <!-- AGREGAR CERTIFICADO - GRUPO -->

                <button type="button" class="btn-add-certificate" *ngIf="es_grupo && loteCertificadosGroup.length > 0"
                    (click)="openBusquedaCertificado(content)">

                    <i class="fa-solid fa-plus"></i>

                    <span>
                        Agregar certificado
                    </span>

                </button>


                <!-- AGREGAR GRUPO -->

                <button type="button" class="btn-add-group" *ngIf="es_grupo && loteCertificadosGroup.length === 0"
                    (click)="openBusquedaGrupos(grupos)" data-tour="btn-agregar-grupos">

                    <i class="fa-solid fa-users"></i>

                    <span>
                        Agregar grupo
                    </span>

                </button>

            </div>


            <!-- AYUDA -->

            <button type="button" class="help-btn" (click)="onHelp(true)" aria-label="Ayuda" title="Ayuda">

                <i class="fa fa-info"></i>

            </button>

        </div>


        <!-- ================================================== -->
        <!-- TABS -->
        <!-- ================================================== -->

        <div class="tabs-container">

            <ul class="nav nav-tabs certificates-tabs" id="myTab" role="tablist">


                <!-- ========================================== -->
                <!-- FIRMANTES -->
                <!-- ========================================== -->

                <li class="nav-item" role="presentation" *ngIf="es_grupo">

                    <button class="nav-link active" id="grupo-tab" data-bs-toggle="tab" data-bs-target="#grupo"
                        type="button" role="tab" aria-controls="grupo" aria-selected="true"
                        (click)="indexLoteCertificadoGroup()" data-tour="tab-firmantes">

                        <i class="fa-solid fa-users"></i>

                        <span>
                            Firmantes
                        </span>

                    </button>

                </li>


                <!-- ========================================== -->
                <!-- CERTIFICADOS -->
                <!-- ========================================== -->

                <li class="nav-item" role="presentation">

                    <button #certificadoBtn class="nav-link" [class.active]="!es_grupo" id="certificado-tab"
                        data-bs-toggle="tab" data-bs-target="#certificado" type="button" role="tab"
                        aria-controls="certificado" [attr.aria-selected]="!es_grupo" (click)="indexLoteCertificado()"
                        data-tour="tab-certificados">

                        <i class="fa-solid fa-certificate"></i>

                        <span>
                            Certificados
                        </span>

                    </button>

                </li>

            </ul>

        </div>


        <!-- ================================================== -->
        <!-- TAB CONTENT -->
        <!-- ================================================== -->

        <div class="tab-content certificates-tab-content" id="myTabContent">


            <!-- ================================================= -->
            <!-- CERTIFICADOS -->
            <!-- ================================================= -->

            <div class="tab-pane fade" [class.show]="!es_grupo" [class.active]="!es_grupo" id="certificado"
                role="tabpanel" aria-labelledby="certificado-tab">


                <!-- ============================================= -->
                <!-- TABLA -->
                <!-- ============================================= -->

                <div class="certificate-table-wrapper" *ngIf="loteCertificados.length > 0; else noLoteCertificados">

                    <div class="table-responsive">

                        <table class="table certificates-table">

                            <caption class="visually-hidden">
                                Tabla Lotes
                            </caption>


                            <thead>

                                <tr>

                                    <th scope="col">
                                        ID
                                    </th>

                                    <th scope="col">
                                        Orden de firma
                                    </th>

                                    <th scope="col">
                                        Scratchcard
                                    </th>

                                    <th scope="col">
                                        Username
                                    </th>

                                    <th scope="col">
                                        Email
                                    </th>

                                    <th scope="col">
                                        Grupo
                                    </th>

                                    <th scope="col">
                                        Vigencia desde
                                    </th>

                                    <th scope="col">
                                        Vigencia hasta
                                    </th>

                                    <th scope="col" class="col-actions">

                                        Acciones

                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                <tr *ngFor="let loteCertificado of loteCertificados;index as i">

                                    <td>
                                        {{ loteCertificado.id }}
                                    </td>

                                    <td>
                                        {{ maxOrdenCertificado - i }}
                                    </td>

                                    <td>
                                        {{ loteCertificado.scratchcard }}
                                    </td>

                                    <td>
                                        {{ loteCertificado.usuario.username }}
                                    </td>

                                    <td>
                                        {{ loteCertificado.usuario.email }}
                                    </td>

                                    <td>

                                        <span class="group-value" [class.no-group]="!loteCertificado.grupo">

                                            {{
                                            loteCertificado.grupo
                                            ? loteCertificado.grupo.nombre
                                            : 'NO APLICA'
                                            }}

                                        </span>

                                    </td>

                                    <td>

                                        {{
                                        loteCertificado.fechaVigenciaDesde
                                        | date:'dd/MM/yyyy':'UTC'
                                        }}

                                    </td>

                                    <td>

                                        {{
                                        loteCertificado.fechaVigencia
                                        | date:'dd/MM/yyyy':'UTC'
                                        }}

                                    </td>


                                    <!-- ========================= -->
                                    <!-- ACCIONES -->
                                    <!-- ========================= -->

                                    <td class="col-actions">

                                        <div class="table-actions">


                                            <!-- ASOCIAR -->

                                            <button type="button" class="table-action table-action-add" *ngIf="
                                                    lote.firma_por_plantilla &&
                                                    loteCertificado.loteDetalleUrlCoordenada?.length == 0
                                                " id="add-cert" title="Asociar certificado" (click)="openAsociacionCertificadoCoordenada(
                                                    modalAsociarCoordenada,
                                                    loteCertificado.id
                                                )">

                                                <i class="fa-solid fa-plus"></i>

                                            </button>


                                            <!-- ELIMINAR -->

                                            <button type="button" class="table-action table-action-delete"
                                                id="trash-cert" title="Eliminar certificado"
                                                (click)="eliminarLoteCertificado(loteCertificado)">

                                                <i class="fa-solid fa-trash"></i>

                                            </button>

                                        </div>

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>


                <!-- ============================================= -->
                <!-- EMPTY STATE -->
                <!-- ============================================= -->

                <ng-template #noLoteCertificados>

                    <div class="empty-state">

                        <div class="empty-state-icon">

                            <i class="fa-solid fa-certificate"></i>

                        </div>

                        <h6>
                            Sin certificados
                        </h6>

                        <p>
                            Aún no has agregado ningún certificado.
                        </p>

                    </div>

                </ng-template>

            </div>


            <!-- ================================================= -->
            <!-- FIRMANTES / GRUPOS -->
            <!-- ================================================= -->

            <div class="tab-pane fade" [class.show]="es_grupo" [class.active]="es_grupo" id="grupo" role="tabpanel"
                aria-labelledby="grupo-tab" *ngIf="es_grupo">


                <div class="certificate-table-wrapper" *ngIf="
                        loteCertificadosGroup.length > 0;
                        else noLoteCertificadosGroup
                    ">

                    <div class="table-responsive">

                        <table class="table certificates-table">

                            <caption class="visually-hidden">
                                Tabla Grupo
                            </caption>


                            <thead>

                                <tr>

                                    <th scope="col" class="col-index">

                                        #

                                    </th>

                                    <th scope="col">
                                        Nombre
                                    </th>

                                    <th scope="col" class="col-actions">

                                        Acciones

                                    </th>

                                </tr>

                            </thead>


                            <tbody>

                                <tr *ngFor="
                                        let loteCertificadoGroup of loteCertificadosGroup;
                                        let i = index
                                    ">

                                    <td class="col-index">
                                        {{ i + 1 }}
                                    </td>

                                    <td>
                                        {{ loteCertificadoGroup.nombre }}
                                    </td>

                                    <td class="col-actions">

                                        <div class="table-actions">

                                            <button type="button" class="table-action table-action-delete"
                                                id="trash-cert" title="Eliminar certificado"
                                                *ngIf="!loteCertificadoGroup.id_grupo"
                                                (click)="eliminarLoteCertificado(loteCertificadoGroup)">

                                                <i class="fa-solid fa-trash"></i>

                                            </button>

                                            <button type="button" class="table-action table-action-delete" *ngIf="loteCertificadoGroup.id_grupo"
                                                id="trash-cert" title="Eliminar grupo" (click)="eliminarGrupoCertificado(
                                                    loteCertificadoGroup
                                                )">

                                                <i class="fa-solid fa-trash"></i>

                                            </button>

                                        </div>

                                    </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>


                <ng-template #noLoteCertificadosGroup>

                    <div class="empty-state">

                        <div class="empty-state-icon">

                            <i class="fa-solid fa-users"></i>

                        </div>

                        <h6>
                            Sin firmantes
                        </h6>

                        <p>
                            Aún no has agregado ningún grupo.
                        </p>

                    </div>

                </ng-template>

            </div>

        </div>

    </div>

</div>


<!-- ======================================================== -->
<!-- MODAL BUSCAR CERTIFICADOS -->
<!-- ======================================================== -->

<ng-template #content let-modal>

    <div class="modal-header custom-modal-header">

        <div class="modal-heading">

            <div class="modal-heading-icon">

                <i class="fa-solid fa-magnifying-glass"></i>

            </div>

            <div>

                <h4 class="modal-title">
                    Búsqueda de Certificados
                </h4>

                <p class="modal-subtitle">
                    Agrega certificados de forma individual o mediante grupos.
                </p>

            </div>

        </div>


        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        </button>

    </div>


    <div class="modal-body custom-modal-body">


        <!-- AYUDA -->

        <div class="modal-toolbar">

            <button type="button" class="help-btn" (click)="onHelpBuscarCertificado(true)" title="Ayuda">

                <i class="fa fa-info"></i>

            </button>

        </div>


        <!-- BÚSQUEDA INDIVIDUAL -->

        <div class="search-card">

            <app-search-certificate-component [disabled]="btnDisabled" #searchCertificate
                (agregarCertificado)="agregarCertificadoLote($event)">
            </app-search-certificate-component>

        </div>


        <!-- BÚSQUEDA POR GRUPO -->

        <div class="search-card">

            <div class="search-card-header">

                <div class="search-card-icon">

                    <i class="fa-solid fa-users"></i>

                </div>

                <div>

                    <h6>
                        Búsqueda por grupo
                    </h6>

                    <p>
                        Selecciona un grupo o subgrupo para agregar
                        todos los certificados asociados.
                    </p>

                </div>

            </div>


            <app-search-group [loteId]="lote?.id" [callback]="resultGroupSelected">
            </app-search-group>

        </div>

    </div>


    <div class="modal-footer custom-modal-footer">

        <button type="button" class="btn-secondary-custom" (click)="modal.close('Cerrar click')">

            Cerrar

        </button>

    </div>

</ng-template>


<!-- ======================================================== -->
<!-- MODAL ASOCIAR CERTIFICADO -->
<!-- ======================================================== -->

<ng-template #modalAsociarCoordenada let-modal>

    <div class="modal-header custom-modal-header">

        <div class="modal-heading">

            <div class="modal-heading-icon">

                <i class="fa-solid fa-link"></i>

            </div>

            <div>

                <h4 class="modal-title">
                    Asociar certificado a firma
                </h4>

                <p class="modal-subtitle">
                    Selecciona la posición de firma que deseas asociar.
                </p>

            </div>

        </div>


        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        </button>

    </div>


    <div class="modal-body custom-modal-body">

        <form [formGroup]="formAsociarCertificado">

            <div class="field-group">

                <label class="form-label" for="id_plantilla_coordenada">

                    Posición de firma

                </label>


                <select id="id_plantilla_coordenada" class="form-select" formControlName="id_plantilla_coordenada"
                    (change)="validateCargo()">

                    <option [ngValue]="null">
                        -- Seleccione --
                    </option>

                    <option *ngFor="let coordenada of plantillaCoordenadas" [ngValue]="coordenada">

                        {{ coordenada.descripcion }}

                    </option>

                </select>

            </div>

        </form>

    </div>


    <div class="modal-footer custom-modal-footer">

        <button type="button" class="btn-primary-custom" (click)="asociarFirmaCertificado()" *ngIf="asigCargo"
            [disabled]="btnDisable">

            <i class="fa-solid fa-link"></i>

            Asociar

        </button>


        <button type="button" class="btn-secondary-custom" (click)="modal.close('Cerrar click')">

            Cerrar

        </button>

    </div>

</ng-template>


<!-- ======================================================== -->
<!-- MODAL GRUPOS -->
<!-- ======================================================== -->

<ng-template #grupos let-modal>

    <div class="modal-header custom-modal-header">

        <div class="modal-heading">

            <div class="modal-heading-icon">

                <i class="fa-solid fa-users"></i>

            </div>

            <div>

                <h4 class="modal-title">
                    Agregar grupo
                </h4>

                <p class="modal-subtitle">
                    Selecciona los firmantes que deseas agregar al sobre.
                </p>

            </div>

        </div>


        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        </button>

    </div>


    <div class="modal-body custom-modal-body">


        <!-- AYUDA -->

        <div class="modal-toolbar">

            <button type="button" class="help-btn" (click)="onHelpModalAgregarGrupo(true)" aria-label="Ayuda"
                title="Ayuda">

                <i class="fa-solid fa-circle-question"></i>

            </button>

        </div>


        <!-- SELECTOR GRUPO -->

        <div class="search-card" data-tour="selector-grupos">

            <div class="search-card-header">

                <div class="search-card-icon">

                    <i class="fa-solid fa-layer-group"></i>

                </div>

                <div>

                    <h6>
                        Seleccionar grupo
                    </h6>

                    <p>
                        Selecciona el grupo que quieres agregar como firmante.
                    </p>

                </div>

            </div>


            <app-groups (idGroup)="groupChange($event)">
            </app-groups>

        </div>


        <!-- USUARIOS -->

        <div class="group-users">

            <app-paginacion [currentPage]="currentPage" [totalItems]="totalItems" [selectedPageSize]="pageSize"
                [paginatedData]="currentItems" [headers]="tableHeaders" [actions]="customActions"
                (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)" [loading]="spinner"
                data-tour="columna-acciones">
            </app-paginacion>

        </div>


        <!-- EXCLUIDOS -->

        <div class="excluded-section" data-tour="seccion-excluidos">

            <div class="excluded-header">

                <div>

                    <h6>
                        Excluidos
                    </h6>

                    <p>
                        Usuarios excluidos del grupo seleccionado.
                    </p>

                </div>

            </div>


            <div class="table-responsive">

                <table class="table certificates-table">

                    <caption class="visually-hidden">
                        Tabla Excluidos
                    </caption>


                    <thead>

                        <tr>

                            <th class="col-index">
                                #
                            </th>

                            <th scope="col">
                                Nombre
                            </th>

                            <th scope="col">
                                Correo
                            </th>

                            <th scope="col">
                                Grupo
                            </th>

                            <th class="col-actions" data-tour="seccion-excluidos-acciones">

                                Acciones

                            </th>

                        </tr>

                    </thead>


                    <tbody>

                        <tr *ngFor="let item of userArrayExcluir; let i = index">

                            <td class="col-index">
                                {{ i + 1 }}
                            </td>

                            <td>
                                {{ item.nombre }}
                            </td>

                            <td>
                                {{ item.correo }}
                            </td>

                            <td>
                                {{ item.grupo }}
                            </td>

                            <td class="col-actions">

                                <button type="button" class="table-action table-action-add" title="Incluir nuevamente"
                                    (click)="incluirUserGroup(item)">

                                    <i class="fa-solid fa-left-long"></i>

                                </button>

                            </td>

                        </tr>


                        <tr *ngIf="userArrayExcluir.length === 0">

                            <td colspan="5" class="empty-table">

                                No hay usuarios excluidos.

                            </td>

                        </tr>

                    </tbody>

                </table>

            </div>

        </div>

    </div>


    <div class="modal-footer custom-modal-footer">

        <button type="button" class="btn-primary-custom" (click)="excluir()" data-tour="btn-guardar-seleccion-grupo">

            <i class="fa-solid fa-check"></i>

            Guardar

        </button>


        <button type="button" class="btn-secondary-custom" (click)="modal.close('Cerrar click')">

            Cerrar

        </button>

    </div>

</ng-template>